import { ICON__chevron_down } from '@/assets/icons_fa';
import { UI_PRIMITIVE__dropdown_menu } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu';
import { UI_PRIMITIVE__dropdown_menu_content } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_content';
import { UI_PRIMITIVE__dropdown_menu_item } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_item';
import { UI_PRIMITIVE__dropdown_menu_trigger } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_trigger';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { local_user_settings_upsert } from '@/state/user/settings/local_user_settings_upsert';
import { REMOTE__user_settings_update } from '@/state/user/settings/REMOTE__user_settings_update';
import { md } from '@/utils/utils_html';
import { DTO__user_settings } from '@shared/dto/+user/user_settings/DTO__user_settings';
import { useTranslation } from 'react-i18next';

interface Props {
  setting_key: keyof DTO__user_settings;
  values: string[];
  title: string;
}
export function DropdownSettingUserBase({ setting_key, title, values }: Props) {
  const dispatch = use_dispatch();

  const { t, i18n } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  const { user_settings } = use_slice_user(['user_settings']);

  const trigger_id = `dropdown_setting_user_base_${setting_key}`;

  /*
   * EVENTS
   */
  async function on_item_selected(value: string) {
    let update: any = {};
    update[setting_key] = value;

    const settingsNew = user_settings.clone(update);
    await dispatch(REMOTE__user_settings_update(settingsNew));
    dispatch(local_user_settings_upsert(settingsNew));
  }

  /*
   * METHODS
   */
  function render_items() {
    return values.map(value => {
      return (
        <UI_PRIMITIVE__dropdown_menu_item
          key={value}
          className="settings-dropdown-item flex items-center justify-center  text-page-foreground"
          class_name_hovered_selected="bg-accent"
          values_selected={[user_settings[setting_key]]}
          label={t(i18n_page_settings_user.tabs.ui.dropdown[setting_key].item[value])}
          {...{ on_item_selected, value }}
        />
      );
    });
  }

  /*
   * HTML
   */
  return (
    <div className={`settings-dropdown-wrapper ${md('flex-col items-start justify-start gap-1 mt-7', '')}`}>
      <span>{title}</span>
      <UI_PRIMITIVE__dropdown_menu>
        <UI_PRIMITIVE__dropdown_menu_trigger asChild>
          <UI_PRIMITIVE__button
            id={trigger_id}
            className={`settings-dropdown-button relative  text-page-foreground ${md('w-full', '')}`}
            variant="outline-on-component"
          >
            {t(i18n_page_settings_user.tabs.ui.dropdown[setting_key].item[user_settings[setting_key]])}
            <ICON__chevron_down className="!w-3 !h-3 absolute right-3 top-3.3" />
          </UI_PRIMITIVE__button>
        </UI_PRIMITIVE__dropdown_menu_trigger>
        <UI_PRIMITIVE__dropdown_menu_content trigger_id={trigger_id} className={`rounded-lg ${md('w-[calc(100vw-52px)]', '')}`}>
          {render_items()}
        </UI_PRIMITIVE__dropdown_menu_content>
      </UI_PRIMITIVE__dropdown_menu>
    </div>
  );
}
